module.exports = __webpack_public_path__ + "static/media/logodarkstatic.f3cffe8c.png";